import { UserRole } from "../../utils/consts";

// Tab definitions - using correct user_type values expected by backend
export const USERS_TABS = {
	LegalEase: "internal", // LegalEASE users are internal users
	Providers: "external" // Provider users are external users
} as const;

export type UserTabKey = (typeof USERS_TABS)[keyof typeof USERS_TABS];

// Role options for filtering
export const ROLE_OPTIONS = Object.entries(UserRole)
	.map(([key, value]) => ({
		label: value,
		value: value
	}))
	.sort((a, b) => (a.label < b.label ? -1 : 1));

// Status options for filtering
export const STATUS_OPTIONS = [
	{ label: "Active", value: "active" },
	{ label: "Pending", value: "pending" },
	{ label: "Disabled", value: "disabled" }
];

// Tab display labels - using enum keys, not user_type values
export const TAB_LABELS = {
	LegalEase: "LegalEASE",
	Providers: "Providers"
} as const;
